import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84607a80"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.nft.onchainMetadata.updateAuthority.indexOf('3MVNxkY9yB2dTXhXAGpner1NzXDKWZBEtT3oCzhtjS3D') != -1 && _ctx.nft.externalMetadata.name.toLowerCase().indexOf('bizarre platypus') != -1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["cardx", { 'card-selected': _ctx.selected, info: _ctx.info, 'notSelected': _ctx.notSelected, 'block-card': _ctx.block }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.nft.externalMetadata.image,
          alt: _ctx.nft.onchainMetadata.data.name
        }, null, 8, _hoisted_1)
      ], 2))
    : _createCommentVNode("", true)
}